export default __webpack_public_path__ + "locales/sr-Cyrl-RS/EmbeddingPanel.json?hash=16cd381f67c725601ab663392df1f9bc";